import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/components/button.css';

const TalentTestIntro: React.FC = () => {
  const navigate = useNavigate();

  const startTest = () => {
    navigate('/talent-test');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-white p-8 rounded-lg shadow-md">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">发现你的特质</h1>
        
        <div className="space-y-4 text-gray-700">
          <div>
            <h2 className="text-xl font-semibold mb-2">测评说明</h2>
            <p>测评包含34个才干维度，每个维度10个描述性问题，请根据实际情况选择符合的选项。</p>
          </div>
          
          <div>
            <h2 className="text-xl font-semibold mb-2">评分方式</h2>
            <p>0分 = 不存在，1分 = 有一点，2分 = 是这样</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">预计用时</h2>
            <p>30-50分钟</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">特别提醒</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>准备充分的时间和安静的环境，测评不能中途退出，退出前面就白做了。</li>
              <li>进入测评后，在提交之前，你随时可以修改选项，也可以通过返回上一页修改上一组题目的选项，测评也没有时间限制，根据自己情况选择即可。</li>
              <li>请自行截图保留你的34才干排序，我们不会保留你的任何数据；团队客户生成定制报告的时候，万一报告生成失败，联系服务人员即可。</li>
            </ul>
          </div>
        </div>

        <div className="text-center mt-8">
          <button 
            onClick={startTest}
            className="btn-primary"
          >
            开始测评
          </button>
        </div>
      </div>
    </div>
  );
};

export default TalentTestIntro;